module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/312362fef257216b1c6fd788237d3831.png";